<template>
  <div>
    <b-modal
      v-show="!loader"
      id="bailiff-modal"
      ref="bailiff-modal"
      :no-close-on-backdrop="true"
      ok-only
      ok-variant="primary"
      :ok-title="$t('DEBTIA_BAILIFFMODAL_BUTTONTEXT')"
      title="Bailiff Module"
      size="sm"
      modal-class="modal-primary"
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="loader === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          v-if="alertError"
          variant="warning"
          show
        >
          <div class="alert-body">
            <span>{{ alertError }}</span>
          </div>
        </b-alert>
        <div
          class="card-profile"
        >
          <h3>{{ $t('DEBTIA_BAILIFFMODAL_HEADERTEXT') }}</h3>
          <p class="text-left">
            {{ $t('DEBTIA_BAILIFFMODAL_TEXT') }}</p>
        </div>
        <b-form>
          <validation-observer
            ref="bailifRules"
            tag="form"
          >
            <b-row>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_BAILIFF_RESUME')"
                  label-for="resume"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Resume"
                    rules="required"
                  >
                    <b-form-textarea
                      id="resume"
                      v-model="resume"
                      placeholder="Resume"
                      rows="8"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-checkbox
                  v-model="bailiffCheck"
                  :checked="bailiffCheck"
                  name="check-button"
                  switch
                  inline
                >
                  {{ $t('DEBTIA_BAILIFF_INSOLVENS') }}
                </b-form-checkbox>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BForm, BOverlay, BFormTextarea, BAlert, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import constants from '@/app-configs/constants'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BOverlay,
    BFormTextarea,
    BAlert,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    caseId: {
      type: [Number, String],
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    switchLoader: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      bailiffCheck: false,
      resume: '',
      snowOption: {
        theme: 'snow',
      },
      loader: false,
      required,
      alertError: null,
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
    open() {
      this.$nextTick(() => {
        const modal = this.$refs['bailiff-modal']
        if (modal && typeof modal.show === 'function') {
          modal.show()
        }
      })
    },
    submitHandler(evt) {
      evt.preventDefault()
      return this.$refs.bailifRules.validate().then(success => {
        if (success) {
          this.loader = true
          const obj = {
            resume: this.resume,
            case_id: this.caseId,
            checkBox: this.bailiffCheck,
          }
          axios.post('/process/bailiff-conclusion', obj).then(response => {
            if (response.status) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CoffeeIcon',
                  variant: 'primary',
                  text: 'Data has been updated successfully.',
                },
              })
              this.loader = false
              this.$refs['bailiff-modal'].hide()
              this.switchLoader()
              this.reloadMethod()
            }
          }).catch(err => {
            this.loader = false
            if (err.response.data.message) {
              this.alertError = err.response.data.message
            }
          })
        } else {
          this.loading = false
        }
      })
    },
  },
}
</script>

<style lang="scss">

.text-left {
  text-align: left !important;
}
</style>
